import Fresh from '@/page/weigh/speciality/Fresh';
import Press from '@/page/weigh/speciality/Press';
import Goods from '@/page/weigh/speciality/Goods';
import Order from '@/page/weigh/speciality/Order';
import OrderAdd from '@/page/weigh/speciality/OrderAdd'
import Taste from '@/page/weigh/speciality/Taste'
import CleanDetail from '@/components/template/detail';
import Sell from '@/page/weigh/query/Sell';
import Produce from '@/page/weigh/query/Produce';
import Analysis from '@/page/weigh/query/Analysis';
import Grading from '@/page/weigh/speciality/Grading';
import Unit from '@/page/weigh/speciality/Unit';
import Mixed from '@/page/weigh/speciality/Mixed';
import Gift from '@/page/weigh/speciality/Gift';

export const weigh = [
  {
    path: '/weigh/speciality/fresh',
    name: 'fresh',
    component: Fresh,
    meta: {
      requireAuth: true,
      title: '生鲜商品'
    },
  },
  {
    path: '/weigh/speciality/press',
    name: 'press',
    component: Press,
    meta: {
      requireAuth: true,
      title: '鲜榨商品'
    },
  },
  {
    path: '/weigh/speciality/goods',
    name: 'goods',
    component: Goods,
    meta: {
      requireAuth: true,
      title: '日清商品'
    },
  },
  {
    path: '/weigh/speciality/order',
    name: 'order',
    component: Order,
    meta: {
      requireAuth: true,
      title: '日清单据'
    },
  },
  {
    path: '/weigh/speciality/order/add',
    name: 'orderAdd',
    component: OrderAdd,
    meta: {
      requireAuth: true,
      title: '日清单 - '
    },
  },
  {
    path: '/weigh/speciality/order/detail',
    name: 'cleanDetail',
    component: CleanDetail,
    meta: {
      requireAuth: true,
      title: '日清单 - '
    },
  },
  {
    path: '/weigh/speciality/taste',
    name: 'taste',
    component: Taste,
    meta: {
      requireAuth: true,
      title: '加价、做法、特价拍'
    },
  },
  {
    path: '/weigh/query/sell',
    name: 'sell',
    component: Sell,
    meta: {
      requireAuth: true,
      title: '生鲜销售报表'
    },
  },
  {
    path: '/weigh/query/analysis',
    name: 'analysis',
    component: Analysis,
    meta: {
      requireAuth: true,
      title: '生鲜分析报表'
    },
  },
  {
    path: '/weigh/query/produce',
    name: 'produce',
    component: Produce,
    meta: {
      requireAuth: true,
      title: '生鲜出品率报表'
    },
  },
  {
    path: '/weigh/speciality/grading',
    name: 'grading',
    component: Grading,
    meta: {
      requireAuth: true,
      title: '商品分级、分割'
    },
  },
  {
    path: '/weigh/speciality/unit',
    name: 'unit',
    component:Unit,
    meta: {
      requireAuth: true,
      title: '按个销售'
    },
  },
  {
    path: '/weigh/speciality/mixed',
    name: 'mixed',
    component: Mixed,
    meta: {
      requireAuth: true,
      title: '商品混售'
    },
  },
  {
    path: '/weigh/speciality/gift',
    name: 'gift',
    component: Gift,
    meta: {
      requireAuth: true,
      title: '礼品销售'
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/weigh.route.js